import { __awaiter } from "tslib";
import { axiosClient } from '@as-react/common-utils';
class ProductPlacementCopyAPI {
    fetchPPC(text, root) {
        return __awaiter(this, void 0, void 0, function* () {
            let ppcHTMLEndpoint = text;
            if (ppcHTMLEndpoint.indexOf('.partial') === -1) {
                ppcHTMLEndpoint = ppcHTMLEndpoint.replace('.html', '.partial.html');
            }
            ppcHTMLEndpoint = ppcHTMLEndpoint.replace('/', root);
            const sizeGuideHTMLRequest = yield axiosClient.get(ppcHTMLEndpoint);
            return sizeGuideHTMLRequest.data;
        });
    }
}
export default new ProductPlacementCopyAPI();
